import React from 'react';
import { EditInline } from '../../shared/actions/actionButtons';
import { QueryGrid, QueryGridSelectMode } from '../../shared/grid/queryGrid/queryGrid';
import { AFTER_HOUR_REFERRAL_RULE } from '../../../permissions';

import styles from './afterHourReferralRulesList.module.css';

export const AfterHourReferralRulesList = (props) => {
    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='After Hour Referral Rule'
        pluralResourceName='After Hour Referral Rules'
        nameFunction={r => r.name}
        restEndpoint='/afterHourReferralRule'
        listUrl='/afterHourReferralRule'
        actions={[EditInline]}
        readPermissions={[AFTER_HOUR_REFERRAL_RULE.READ]}
        writePermissions={[AFTER_HOUR_REFERRAL_RULE.WRITE]}
        editMode={true}
        columns={{
            location: {
                label: 'Location',
            },
            referral: {
                label: 'Referral',
            },
        }}
        selectMode={QueryGridSelectMode.None}
        {...props}
    />
}